import React from 'react';

const PageTitleServicesInside = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">Listă servicii</h1>
            </div>
        </div>
    );
};

export default PageTitleServicesInside;
